const { instance } = require('./url')
const {
    CustomerCompanyModel,
} = require('../CustomerCompanyModel')

async function getCustomerCompanyInfo(companyName='') {
    return await instance.get('/company_info/'+companyName).then(
        (result) => {
            return result.data.company_info
        },
        (error) => {
            return CustomerCompanyModel.from({
                'companyName': companyName,
            })
        }
    )
}

async function getMultipleCustomerCompanyInfo(companyNames=[]) {
    return await instance.post(
        '/company_info/get_company_infos',
        {
            'company_names': companyNames,
        }
    ).then(
        (result) => {
            const asMap = {}
            for (let i = 0; i < companyNames.length; i++) {
                asMap[companyNames[i]] = new CustomerCompanyModel()
            }

            for (let i = 0; i < result.data.company_infos.length; i++) {
                asMap[result.data.company_infos[i].company] = result.data.company_infos[i]
            }
            return asMap
        },
    )
}

async function insertCustomerCompanyInfo(companyInfo, isCustomer) {
    if (isCustomer) {
        delete companyInfo['payment_terms_text']
        delete companyInfo['payment_days']
    }
    return await instance.post(
        '/company_info',
        {
            'company_info': companyInfo,
        },
    ).then(
        (result) => {
            return result.data.company_info
        },
    )
}

async function updateCustomerCompanyInfo(companyInfo, isCustomer) {
    if (isCustomer) {
        delete companyInfo['payment_terms_text']
        delete companyInfo['payment_days']
    }
    return await instance.put(
        '/company_info',
        {
            'company_info': companyInfo,
        },
    ).then(
        (result) => {
            return result.data.company_info
        },
    )
}

export {
    getCustomerCompanyInfo,
    getMultipleCustomerCompanyInfo,
    insertCustomerCompanyInfo,
    updateCustomerCompanyInfo
}

